// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalJustificativa_iconHeader__Pt2Ee","form":"ModalJustificativa_form__iNcBt"};